import React from 'react';
import Media from 'react-media';

import Mobile from './Mobile';
import Desktop from './Desktop';
import MediaContext from './MediaContext';
import AppContainer from './Containers/App';
import useMeasureContentMain from '~/react-hooks/use-measure-content-main';
import { TaskCreationModal } from './Components/TaskCreationModal';
import { NAV_HEADER_HEIGHT_IN_PX } from '~/App/Components/NavHeaderItems';
import { WhatAreCustomFieldsModal } from '~/App/Components/Modals/WhatAreCustomFieldsModal';

export default function App() {
  const contentMain = useMeasureContentMain();

  return (
    <AppContainer
      style={{ height: contentMain.height - NAV_HEADER_HEIGHT_IN_PX }}
    >
      <Media query={{ maxWidth: 768 }}>
        {(isMobile) => {
          const ChildComponent = isMobile ? Mobile : Desktop;

          return (
            <MediaContext.Provider value={isMobile}>
              <ChildComponent />
            </MediaContext.Provider>
          );
        }}
      </Media>
      <TaskCreationModal />
      <WhatAreCustomFieldsModal />
    </AppContainer>
  );
}
